import Tabela from "../../../../Misc/Tabela/Tabela";
import styles from '../../pa_checklist_followup.module.scss';

const TabelaResumoFup = (params) => {
  const {
    colunasDinamicas,
    filtro,
    porEntradaF,
    porPecasF,
    porProdutosF,
    porVerbaF,
    porEntradaP,
    porPecasP,
    porProdutosP,
    porVerbaP,
    loading
  } = params;

  const acc = (arr) => {
    return arr.reduce((acc, item) => acc + item.valor, 0);
  }

  const accTotal = (arr1, arr2) => {
    const total1 = arr1.reduce((acc, item) => acc + item.valor, 0);
    const total2 = arr2.reduce((acc, item) => acc + item.valor, 0);
    const total = (total1 * 100) / (total1 + total2);
    return (isNaN(total) ? 0 : total.toFixed(2)) + '%';
  }

  const strToNumericReducer = (arr) => {
    return arr.reduce((sum, item) => {
      const raw = item.valor.replace(/[^\d,]/g, '').replace(',', '.');
      const numeric = parseFloat(raw);
      return sum + numeric;
    }, 0);
  }

  const accVerba = (arr) => {
    const total = strToNumericReducer(arr);
    return total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  const accVerbaTotal = (arr1, arr2) => {
    const total1 = strToNumericReducer(arr1);
    const total2 = strToNumericReducer(arr2);
    const total = (total1 * 100) / (total1 + total2);
    return (isNaN(total) ? 0 : total.toFixed(2)) + '%';
  }

  return (
    <section>
      <div className={styles.header_only_datatable}>
        <Tabela
          columns={colunasDinamicas[filtro]}
          data={[]}
          noHeader={false}
          noTableHead={false}
          persistTableHead={true}
          noDataComponent={false}
        />
      </div>
      <div className={styles.resumo_mini_header}>
        <span className={styles.resumo_row} style={{ textAlign: 'left' }}>Finalizado</span>
        <span className={styles.resumo_row}>
          {
            filtro === 101 ? acc(porEntradaF) :
              filtro === 102 ? accVerba(porVerbaF) :
                filtro === 103 ? acc(porPecasF) :
                  filtro === 104 ? acc(porProdutosF) :
                    []
          }
        </span>
        <span className={styles.resumo_row}>
          {
            filtro === 101 ? accTotal(porEntradaF, porEntradaP):
              filtro === 102 ? accVerbaTotal(porVerbaF, porVerbaP) :
                filtro === 103 ? accTotal(porPecasF, porPecasP) :
                  filtro === 104 ? accTotal(porProdutosF, porProdutosP) :
                    []
          }
        </span>
      </div>
      <Tabela
        columns={colunasDinamicas[filtro]}
        data={
          filtro === 101 ? porEntradaF :
            filtro === 102 ? porVerbaF :
              filtro === 103 ? porPecasF :
                filtro === 104 ? porProdutosF :
                  []
        }
        striped={true}
        pending={loading}
        pagination={false}
        noTableHead={true}
      />
      <div className={styles.resumo_mini_header}>
        <span className={styles.resumo_row} style={{ textAlign: 'left' }}>Pendente</span>
        <span className={styles.resumo_row}>
          {
            filtro === 101 ? acc(porEntradaP) :
              filtro === 102 ? accVerba(porVerbaP) :
                filtro === 103 ? acc(porPecasP) :
                  filtro === 104 ? acc(porProdutosP) :
                    []
          }
        </span>
        <span className={styles.resumo_row}>
          {
            filtro === 101 ? accTotal(porEntradaP, porEntradaF):
              filtro === 102 ? accVerbaTotal(porVerbaP, porVerbaF) :
                filtro === 103 ? accTotal(porPecasP, porPecasF) :
                  filtro === 104 ? accTotal(porProdutosP, porProdutosF) :
                    []
          }
        </span>
      </div>
      <Tabela
        columns={colunasDinamicas[filtro]}
        data={
          filtro === 101 ? porEntradaP :
            filtro === 102 ? porVerbaP :
              filtro === 103 ? porPecasP :
                filtro === 104 ? porProdutosP :
                  []
        }
        striped={true}
        pending={loading}
        pagination={false}
        noTableHead={true}
      />
    </section>
  )
}

export default TabelaResumoFup;
